import React from 'react';

const SvgPdf = (props) => (
  <svg width="10" height="12" viewBox="0 0 10 12" {...props}>
    <path
      fill="currentColor"
      d="m1.25 0c-.684 0-1.25.543-1.25 1.2v9.6c0 .657.566 1.2 1.25 1.2h7.5c.684 0 1.25-.543 1.25-1.2v-7.2l-3.75-3.6zm0 1.2h4.375v3h3.125v6.6h-7.5zm3.645 3c-.344 0-.601.224-.652.614-.05.39.151 1.07.502 1.703-.15.438-.301.827-.502 1.216-.652.195-1.253.486-1.504.778-.4.438-.2.73-.1.876s.251.213.452.213c.1 0 .2-.02.301-.068.402-.146.801-.73 1.203-1.41.35-.098.701-.195 1.052-.243.35.388.703.632 1.003.73.351.097.652-.05.802-.39.1-.293.05-.535-.201-.681-.301-.195-.803-.196-1.404-.147-.2-.292-.4-.583-.55-.875.25-.73.35-1.362.25-1.751-.1-.341-.308-.565-.652-.565z"
    />
  </svg>
);

export default SvgPdf;
